export const isSameString = (a: string, b: string) => {
  if (a == null && b != null) return false;
  if (a != null && b == null) return false;
  if (a == null && b == null) return true;

  return a.localeCompare(b, undefined, { sensitivity: "accent" }) === 0;
};

export const areAddressesTheSame = (address1: server.dto.Address, address2: server.dto.Address) => {
  return isSameString(address1.addressLine1, address2.addressLine1) &&
    isSameString(address1.addressLine2, address2.addressLine2) &&
    isSameString(address1.city, address2.city) &&
    isSameString(address1.postalCode, address2.postalCode) &&
    isSameString(address1.countryName, address2.countryName);
    
};